export var chartOptions = {
  credits: {
    enabled: false
  },
  accessibility: {
    enabled: false
  },
  chart: {
    type: 'scatter',
    zoomType: 'xy'
  },
  legend: {
    enabled: false
  },
  title: {
    text: null
  },
  subtitle: {
    text: null
  },
  xAxis: {
    tickWidth: 0,
    min: -10,
    max: 10,
    title: {
      enabled: true,
      text: 'Rentabilidad'
    },
    startOnTick: true,
    endOnTick: true,
    showLastLabel: true,
    plotLines: [{
      color: '#000',
      width: 1,
      value: 0
    }]
  },
  yAxis: {
    tickWidth: 0,
    plotLines: [{
      color: '#000',
      width: 2,
      value: 0
    }],
    min: -10,
    max: 10,
    title: {
      text: 'Comisión de gestión'
    }
  },
  plotOptions: {
    scatter: {
      tooltip: {
        headerFormat: '',
        pointFormat: '<b>{point.name}</b><br>Rentabilidad {point.x:.2f}%<br>Rentabilidad YTD {point.y:.2f}%'
      }
    }
  },
  series: []
};